/**
 * 手机号归一化。
 *
 * 单独成模块（而不是留在登录页里）有两个理由：
 * 1. `<script setup>` 不允许出现具名导出，`export function normalizePhone` 会让 SFC 编译失败；
 * 2. 它是纯函数，放在 lib 下可以在 vitest 的 node 环境里直接测，不必挂载组件。
 *
 * 契约的 `PhoneSchema` 只接受 E.164（`+` 开头 8–15 位数字），
 * 所以用户输入的 `138 0013 8000` 必须在这里补成 `+8613800138000`，
 * 否则请求会以 40001 被打回。
 */

/** 中国大陆手机号（不带国家码）。 */
const CN_MOBILE_PATTERN = /^1[3-9]\d{9}$/;
/** 已经带国家码的 E.164。 */
const E164_PATTERN = /^\+\d{8,15}$/;

/**
 * `138 0013 8000` → `+8613800138000`；`+8613800138000` → 原样返回；
 * 无法识别 → `null`（调用方据此显示"请输入 11 位手机号"）。
 */
export function normalizePhone(raw: string): string | null {
  const trimmed = raw.replace(/[\s-]/g, '');
  if (CN_MOBILE_PATTERN.test(trimmed)) {
    return `+86${trimmed}`;
  }
  if (E164_PATTERN.test(trimmed)) {
    return trimmed;
  }
  return null;
}
